import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { arenaService } from '@/services/arena';

export function useArenaMedalList() {
    const { list, total, fetchList } = useBaseListView({ request: arenaService.medal.list });
    const { confirmAndRemove } = useCrudActions();

    const actions = {
        remove: confirmAndRemove({
            request: arenaService.medal.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions };
}
